<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-row :gutter="24">
        <a-col :span="4">
          <!-- 部门树 -->
          <dept-tree ref="deptTree" :deptOptions="deptOptions" @select="clickDeptNode" />
        </a-col>
        <a-col :span="20">
          <!-- 条件搜索 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="48">
                <a-col :md="8" :sm="24">
                  <a-form-item label="姓名">
                    <a-input v-model="queryParam.nickName" allow-clear placeholder="请输入" />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="手机号">
                    <a-input v-model="queryParam.phonenumber" allow-clear placeholder="请输入" />
                  </a-form-item>
                </a-col>
                <template v-if="advanced">
                  <a-col :md="8" :sm="24">
                    <a-form-item label="状态" prop="status">
                      <a-select v-model="queryParam.status" allow-clear placeholder="请选择状态" style="width: 100%">
                        <a-select-option v-for="(d, index) in statusOptions" :key="index" :value="d.dictValue">{{ d.dictLabel }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <a-form-item label="创建时间">
                      <a-range-picker v-model="dateRange" allow-clear format="YYYY-MM-DD" style="width: 100%" valueFormat="YYYY-MM-DD" />
                    </a-form-item>
                  </a-col>
                </template>
                <a-col :md="(!advanced && 8) || 24" :sm="24">
                  <span :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="handleQuery">
                      <a-icon type="search" />
                      查询
                    </a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery">
                      <a-icon type="redo" />
                      重置
                    </a-button>
                    <a style="margin-left: 8px" @click="toggleAdvanced">
                      {{ advanced ? '收起' : '展开' }}
                      <a-icon :type="advanced ? 'up' : 'down'" />
                    </a>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- 操作 -->
          <div class="table-operations">
            <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['system:user:add']">
              <a-icon type="plus" />新增
            </a-button> -->
            <a-button v-hasPermi="['system:user:edit']" :disabled="single" type="primary" @click="$refs.createForm.handleUpdate(undefined, ids)">
              <a-icon type="edit" />
              修改
            </a-button>
            <a-button v-hasPermi="['system:user:remove']" :disabled="multiple" type="danger" @click="handleDelete">
              <a-icon type="delete" />
              删除
            </a-button>
            <!-- <a-button
              type="dashed"
              @click="$refs.importExcel.importExcelHandleOpen()"
              v-hasPermi="['system:user:import']"
            >
              <a-icon type="import" />导入
            </a-button> -->
            <a-button v-hasPermi="['system:user:export']" type="primary" @click="handleExport">
              <a-icon type="download" />
              导出
            </a-button>
            <a-button v-hasPermi="['system:user:sync']" type="primary" @click="sync">
              <a-icon type="download" />
              同步企业微信用户数据
            </a-button>
            <table-setting v-model="columns" :refresh-loading="loading" :style="{ float: 'right' }" :table-size.sync="tableSize" @refresh="getList" />
          </div>
          <!-- 增加修改 -->
          <!-- 创建/编辑用户,单独封装了组件 -->
          <create-form
            ref="createForm"
            :deptOptions="deptOptions"
            :sexOptions="sexOptions"
            :statusOptions="statusOptions"
            @ok="getList"
            @select-tree="getTreeselect"
          />
          <!-- 修改密码抽屉 -->
          <reset-password ref="resetPassword" />
          <!-- 分配角色模态框 -->
          <auth-role ref="authRole" />
          <!-- 上传文件 -->
          <import-excel ref="importExcel" @ok="getList" />
          <!-- 数据展示 -->
          <a-table
            :bordered="tableBordered"
            :columns="columns"
            :data-source="list"
            :loading="loading"
            :pagination="false"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :size="tableSize"
            rowKey="userId"
          >
            <span slot="status" slot-scope="text, record">
              <a-popconfirm cancel-text="否" ok-text="是" @cancel="cancelHandleStatus(record)" @confirm="confirmHandleStatus(record)">
                <span slot="title">
                  确认
                  <b>{{ record.status === '1' ? '启用' : '停用' }}</b>
                  {{ record.nickName }}的用户吗?
                </span>
                <a-switch :checked="record.status == 0" checked-children="开" un-checked-children="关" />
              </a-popconfirm>
            </span>
            <span slot="createTime" slot-scope="text, record">
              {{ parseTime(record.createTime) }}
            </span>
            <span v-if="record.userId !== 1" slot="operation" slot-scope="text, record">
              <a v-hasPermi="['system:user:edit']" @click="$refs.createForm.handleUpdate(record, undefined)">
                <a-icon type="edit" />
                修改
              </a>
              <a-divider v-hasPermi="['system:user:remove']" type="vertical" />
              <a v-hasPermi="['system:user:remove']" @click="handleDelete(record)">
                <a-icon type="delete" />
                删除
              </a>
              <a-divider v-hasPermi="['system:user:resetPwd', 'system:user:edit']" type="vertical" />
              <!-- <a-dropdown v-hasPermi="['system:user:resetPwd', 'system:user:edit']">
                <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                  <a-icon type="double-right" />
                  更多
                </a>
                <a-menu slot="overlay">
                  <a-menu-item v-hasPermi="['system:user:resetPwd']">
                    <a @click="$refs.resetPassword.handleResetPwd(record)">
                      <a-icon type="key" />
                      重置密码
                    </a>
                  </a-menu-item>
                  <a-menu-item v-hasPermi="['system:user:edit']">
                    <a @click="$refs.authRole.handleAuthRole(record)">
                      <a-icon type="check-circle" />
                      分配角色
                    </a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown> -->
            </span>
          </a-table>
          <!-- 分页 -->
          <a-pagination
            :current="queryParam.pageNum"
            :page-size="queryParam.pageSize"
            :showTotal="(total) => `共 ${total} 条`"
            :total="total"
            class="ant-table-pagination"
            show-size-changer
            @change="changeSize"
            @showSizeChange="onShowSizeChange"
          />
        </a-col>
      </a-row>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { changeUserStatus, delUser, listUser, syncUser } from '@/api/system/user'
import { treeselect } from '@/api/system/dept'
import AuthRole from './modules/AuthRole'
import ResetPassword from './modules/ResetPassword'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import DeptTree from './modules/DeptTree'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'User',
  components: {
    AuthRole,
    ResetPassword,
    CreateForm,
    ImportExcel,
    DeptTree
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 状态数据字典
      statusOptions: [],
      sexOptions: [],
      // 部门树选项
      deptOptions: [
        {
          id: 0,
          label: '',
          children: []
        }
      ],
      // 日期范围
      dateRange: [],
      queryParam: {
        pageNum: 1,
        pageSize: this.$getters.pageSize,
        nickName: undefined,
        phonenumber: undefined,
        status: 0,
        deptId: undefined
      },
      columns: [
        {
          title: '用户编号',
          dataIndex: 'userNo',
          align: 'center'
        },
        {
          title: '用户名',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'phonenumber',
          align: 'center'
        },
        {
          title: '部门',
          dataIndex: 'dept.deptName',
          scopedSlots: { customRender: 'dept.deptName' },
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created () {
    this.getList()
    this.getTreeselect()
    this.getDicts('sys_normal_disable').then((response) => {
      this.statusOptions = response.data
    })
    this.getDicts('sys_user_sex').then((response) => {
      this.sexOptions = response.data
      console.log('sys_user_sex', this.sexOptions)
    })
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询用户列表 */
    getList () {
      this.loading = true
      listUser(this.addDateRange(this.queryParam, this.dateRange)).then((response) => {
        this.list = response.rows
        this.total = response.total
        this.loading = false
      })
    },
    /** 查询部门下拉树结构 */
    getTreeselect () {
      treeselect().then((response) => {
        this.deptOptions = response.data
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParam = {
        pageNum: 1,
        pageSize: this.$getters.pageSize,
        userName: undefined,
        phonenumber: undefined,
        status: undefined,
        deptId: undefined
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.userId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    clickDeptNode (deptId) {
      this.queryParam.deptId = deptId
      this.handleQuery()
    },
    /* 用户状态修改 */
    confirmHandleStatus (row) {
      const text = row.status === '1' ? '启用' : '关闭'
      row.status = row.status === '0' ? '1' : '0'
      changeUserStatus(row.userId, row.status)
        .then(() => {
          this.$message.success(text + '成功', 3)
        })
        .catch(function () {
          this.$message.error(text + '异常', 3)
        })
    },
    cancelHandleStatus (row) {},
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const userIds = row.userId || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + userIds + '的数据',
        onOk () {
          return delUser(userIds).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download(
            'system/user/export',
            {
              ...that.queryParam
            },
            `user_${new Date().getTime()}.xlsx`
          )
        },
        onCancel () {}
      })
    },
    sync () {
      syncUser().then((response) => {
        this.getList()
      })
    }
  }
}
</script>
